import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { IUserOrganisationsResponse } from 'APIPackage/AccountModule/interfaces/IUserOrganisationsResponse';
import { IKnoOrganisationFunction } from 'APIPackage/AccountModule/interfaces/IKnoOrganisationFunction';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { UserOrgTypesEnum } from '../enums/UserOrgTypesEnum';

/** Параллельные вызовы (UserOrganizationsCheck + KnmForm и др.) — один HTTP-запрос. */
let fetchUserOrganisationsInFlight: Promise<IUserOrganisationsResponse> | null = null;

export async function fetchUserOrganisations(): Promise<IUserOrganisationsResponse> {
  if (fetchUserOrganisationsInFlight) {
    return fetchUserOrganisationsInFlight;
  }

  fetchUserOrganisationsInFlight = apiGet<IUserOrganisationsResponse>(
    `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/general-info/organizations`,
  ).finally(() => {
    fetchUserOrganisationsInFlight = null;
  });

  return fetchUserOrganisationsInFlight;
}

type FetchUserOrganisationsUpdate = [
  {
    organizationType: UserOrgTypesEnum;
    organizationInfo: {
      defaultOrganizationErvkId?: string;
      organizationErvkIds: Array<string>;
    };
  },
  {
    organizationType: UserOrgTypesEnum;
    organizationInfo: {
      defaultOrganizationId?: string;
      organizationIds: Array<string>;
    };
  },
];

export type UserOrganisationsUpdateResponse = {
  [UserOrgTypesEnum.KNO]: IUserOrganisation[];
  [UserOrgTypesEnum.PROSECUTOR]: IUserOrganisation[];
};

export async function fetchUserOrganisationsUpdate(
  data: FetchUserOrganisationsUpdate,
): Promise<UserOrganisationsUpdateResponse> {
  return apiPost<UserOrganisationsUpdateResponse>({
    url: `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/general-info/organizations`,
    body: data,
  });
}

export async function fetchKnoOrganisationFunctions(knoId: string): Promise<IKnoOrganisationFunction[]> {
  return apiGet<IKnoOrganisationFunction[]>(
    `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/general-info/functions/${knoId}`,
  );
}

interface IFetchKnoOrganisationFunctionSetDefault {
  knoId: string;
  functionId: number;
}

export async function fetchKnoOrganisationFunctionSetDefault({
  knoId,
  functionId,
}: IFetchKnoOrganisationFunctionSetDefault): Promise<IKnoOrganisationFunction> {
  return apiPut<IKnoOrganisationFunction>(
    `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/general-info/functions/${knoId}/${functionId}`,
  );
}
